import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getReceiptDraftsURL, getReceiptPosesURL, getReceiptChequesURL ,getReceiptHeadersURL } from '../api';
import moment from 'jalali-moment'

// initial state
export const initialState = {
  loading: false,
  loadingCheques : false,
  loadingPoses : false,
  loadingDrafts : false,
  loadingCashes : false,
  error: false,
  currentPageIndex : 0,
  hasMore : false,
  chequeItems: [],
  draftItems: [],
  posItems: [],
  cashItems: [],
  fetchPermission : true,//برای مواقعی که بک زده میشه از یک فاکتور به فهرست نمیخواهیم مجدد لود شود

  //selectedInvoice : {},
  //selectedInvoiceId : '',

  searchKey : '',
  searchKey_fromdate : '',
  searchKey_todate : ''
};

// our slice
const receiptsSlice = createSlice({
  name: "receipts",
  initialState,
  reducers: {
    setReceiptsLoading: (state) => {
      state.loading = true;
    },
    setDraftsLoading: (state) => {
      state.loadingDrafts = true;
    },
    setPosesLoading: (state) => {
      state.loadingPoses = true;
    },
    setCashesLoading: (state) => {
      state.loadingCashes = true;
    },
    setChequesLoading: (state) => {
      state.loadingCheques = true;
    },
    setReceiptsSearchKey : (state, { payload }) =>{
      state.searchKey = payload;
    },
    setReceiptsSearchKeyFromdate : (state, { payload }) =>{
      state.searchKey_fromdate = payload;
    },
    setReceiptsSearchKeyTodate : (state, { payload }) =>{
      state.searchKey_todate = payload;
    },
    setReceiptsChequeItems: (state, { payload }) => {
      state.loadingCheques = false;
      state.error = false;
      state.chequeItems.push(...payload);
      if(payload.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setReceiptsDraftItems: (state, { payload }) => {
      state.loadingDrafts = false;
      state.error = false;
      state.draftItems.push(...payload);
      if(payload.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setReceiptsCashItems: (state, { payload }) => {
      state.loadingCashes = false;
      state.error = false;
      state.cashItems.push(...payload.filter(e =>  e.Amount > 0));
      if(payload.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setReceiptsPosItems: (state, { payload }) => {
      state.loadingPoses = false;
      state.error = false;
      state.posItems.push(...payload);
      if(payload.length === 0){
        state.hasMore = false;
      }
      console.log("newItems count is " + (payload.length));
      state.currentPageIndex++;
    },
    setReceiptsError: (state) => {
      state.error = true;
    },
    clearReceiptsItems: (state) => {
      state.chequeItems = [];
      state.draftItems = [];
      state.posItems = [];
      state.cashItems = [];
      state.currentPageIndex = 0;
  
    },
    clearReceiptsCashes: (state) => {
      state.cashItems = [];
      state.currentPageIndex = 0;
  
    },
    clearReceiptsPoses: (state) => {
      state.posItems = [];
      state.currentPageIndex = 0;
  
    },
    clearReceiptsCheques: (state) => {
      state.chequeItems = [];
      state.currentPageIndex = 0;
    },
    clearReceiptsDrafts: (state) => {
      state.draftItems = []; 
    },
    clearReceiptsFilters: (state) => {
      state.searchKey = '';
      state.searchKey_fromdate = '';
      state.searchKey_todate = '';
    },
    clearReceiptsData: (state) => {
      
      state.loading = false;
      state.loadingCashesg = false;
      state.loadingCheques = false;
      state.loadingDrafts = false;
      state.loadingPoses = false;
      state.error = false;
      state.currentPageIndex = 0;
      state.chequeItems = [];
      state.draftItems = [];
      state.posItems = [];
      state.cashItems = [];
      state.hasMore = true;
      state.searchKey  = '';
      state.searchKey_fromdate  = '';
      state.searchKey_todate  = '';
      state.fetchPermission = true;

    }
  },
});

// export the actions
export const { setReceiptsLoading, 
  setReceiptsSearchKey,
  setReceiptsSearchKeyFromdate,
  setReceiptsSearchKeyTodate,
  setReceiptsChequeItems,
  setReceiptsDraftItems,
  setReceiptsCashItems,
  setReceiptsPosItems,
  setReceiptsError,
  clearReceiptsItems,
  clearReceiptsFilters,
  clearReceiptsData,
  clearReceiptsCashes,
  clearReceiptsPoses,
  clearReceiptsCheques,
  clearReceiptsDrafts,

  setDraftsLoading,
  setPosesLoading,
  setCashesLoading,
  setChequesLoading
} = receiptsSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const invoiceItemsSelector = (state) => state.items;

// export the default reducer
export default receiptsSlice.reducer;


// fetch all items
export function fetchChequeReceipts(input) {
  return async (dispatch) => {
    console.log("input");
console.log(input);

    var _fd = "";
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    
    var _td = "";
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);

    if(input.pageindex === 0)
      dispatch(clearReceiptsCheques());

    if(input.hasMore){
      dispatch(setChequesLoading());
      await axios.post(getReceiptChequesURL()+'?fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setReceiptsChequeItems(response.data));
      }).catch(function (err) {
        dispatch(setReceiptsError());
      }).finally(()=> {

      });
  }
  };
}

// fetch all items
export function fetchDraftReceipts(input) {
  return async (dispatch) => {
    console.log("input");
console.log(input);

    var _fd = "";
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    
    var _td = "";
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);

    if(input.pageindex === 0)
      dispatch(clearReceiptsDrafts());

    if(input.hasMore){
      dispatch(setDraftsLoading());
      await axios.post(getReceiptDraftsURL()+'?fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setReceiptsDraftItems(response.data));
      }).catch(function (err) {
        dispatch(setReceiptsError());
      }).finally(()=> {

      });
  }
  };
}

// fetch all items
export function fetchPosReceipts(input) {
  return async (dispatch) => {
    console.log("input");
console.log(input);

    var _fd = "";
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    
    var _td = "";
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);

    if(input.pageindex === 0)
      dispatch(clearReceiptsPoses());

    if(input.hasMore){
      dispatch(setPosesLoading());
      await axios.post(getReceiptPosesURL()+'?fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setReceiptsPosItems(response.data));
      }).catch(function (err) {
        dispatch(setReceiptsError());
      }).finally(()=> {

      });
  }
  };
}

// fetch all items
export function fetchCashReceipts(input) {
  return async (dispatch) => {
    console.log("input");
console.log(input);

    var _fd = "";
    _fd = moment.from(input.fromdate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);
    
    var _td = "";
    _td = moment.from(input.todate, 'fa', 'YYYY/MM/DD')._i.toString().slice(0,10);

    if(input.pageindex === 0)
      dispatch(clearReceiptsCashes());

    if(input.hasMore){
      dispatch(setCashesLoading());
      await axios.post(getReceiptHeadersURL()+'?fromDate='+_fd+'&toDate='+_td+'&username='+input.authUser.username + '&password='+encodeURIComponent(input.authUser.password)+'&token='+input.authUser.token)
      .then(response => {
          dispatch(setReceiptsCashItems(response.data));
      }).catch(function (err) {
        dispatch(setReceiptsError());
      }).finally(()=> {

      });
  }
  };
}